var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.role_id == 1)?_c('DashboardAdmin'):(_vm.role_id == 2)?_c('DashboardTeacher'):(_vm.role_id == 3)?_c('DashboardMentor'):(_vm.role_id == 4)?_c('DashboardStudent'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }